import NewFinanceStaticDashboard from "components/finance/NewFinanceStaticDashboard";

const NewFinance = ({ userPermissions, permissionsLoading }) => {
  return <NewFinanceStaticDashboard scope="project" userPermissions={userPermissions} permissionsLoading={permissionsLoading} />;
};

export default NewFinance;
